<template>
  <div :id="page_slug">
    <div class="crumbs-bar">
      <el-row>
        <el-col :span="12">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'DashboardPage' }">Dashboard</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ name: 'TaxList' }">Taxes</el-breadcrumb-item>
            <el-breadcrumb-item>Edit</el-breadcrumb-item>
          </el-breadcrumb>        
        </el-col>      
      </el-row>
    </div>

    <el-tabs type="card" v-model="active_tab">
      <el-tab-pane label="Tax Class Details" name="tax_details">
        <el-form 
          ref="tax" 
          :rules="rules.tax"
          :model="tax"
          :label-position="label_position">

          <el-form-item label="Name" prop="name">
            <el-input v-model="tax.name"></el-input>
          </el-form-item>

          <el-form-item label="Description" prop="description">
            <el-input v-model="tax.description"></el-input>
          </el-form-item>

          <el-form-item label="Sort Order" prop="sort_order">
            <el-input-number :min="0" v-model="tax.sort_order"></el-input-number>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="updateTax('tax')">Update</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <el-tab-pane label="Tax Pricing Matrix" name="tax_rates">
        <el-row class="breather">
          <el-button v-if="!form_rate_show" type="default" @click="toggleFormRate('Add')">Add Tax Rate</el-button>
          <el-button v-if="form_rate_show" type="default" @click="toggleFormRate('')">Cancel</el-button>
        </el-row>

        <el-form
          v-if="form_rate_show"
          ref="matrix" 
          :model="matrix"
          :rules="rules.tax_pricing_matrix"
          :label-position="label_position">

          <el-row :gutter="30">
            <el-col :span="8">
              <el-form-item label="Country" prop="country">
                <el-select 
                  v-model="matrix.country" 
                  placeholder="Select country"
                  :filterable="true"
                  :clearable="false">
                  <el-option v-for="country in country_list" :key="country.code" :label="country.name" :value="country.name"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
        
            <el-col :span="8">
              <el-form-item label="Rate" prop="tax">
                <el-input v-model="matrix.tax"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="State" prop="state">
                <el-input v-model="matrix.state"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-button v-if="form_rate_mode == 'Add'" type="primary" @click="addMatrix('matrix')">{{form_rate_mode}} Tax Rate</el-button>
          <el-button v-if="form_rate_mode == 'Update'" type="primary" @click="updateMatrix('matrix')">{{form_rate_mode}} Tax Rate</el-button>
        </el-form>

        <el-table
          v-if="!form_rate_show"
          :data="tax_pricing_matrix"
          style="width: 100%">
          <el-table-column
            prop="id"
            label="ID"
            width="180">
          </el-table-column>
          <el-table-column
            prop="country"
            label="Country"
            width="180">
          </el-table-column>
          <el-table-column
            prop="state"
            label="State">
          </el-table-column>
          <el-table-column
            prop="tax"
            label="Tax">
          </el-table-column>
          <el-table-column
            label="Actions">
            <template slot-scope="scope">
              <el-button-group>
                <el-button 
                  icon="el-icon-edit"
                  type="default" 
                  size="small"
                  @click="getMatrix(scope.row.id)"></el-button>
              </el-button-group>
              <el-button-group>
                <el-button 
                  icon="el-icon-delete"
                  type="default" 
                  size="small"
                  @click="deleteMatrix(scope.row.id)"></el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>

    </el-tabs>

    <pre>{{$data}}</pre>
  </div>
</template>

<script>
  import Config from '@/store/Config.js';
  import CountryList from '@/components/utils/CountryList.js';
  import Utils from '@/components/utils/Utils.js';
  import Auth from '@/components/auth/AuthCheck.js';
 
  export default {
    data: function() {
      return {
        config: Config.config,
        page_alias: 'Edit Tax',
        page_slug: 'edit-tax',
        label_position: 'top',
        active_tab: 'tax_details',
        loading: false,
        rate: {},
        form_rate_show: false,
        form_rate_mode: '',
        country_list: CountryList.countries,
        rules: {
          tax: {
            name: [
              { required: true, message: 'Please Enter Name', trigger: 'blur' }
            ],
            description: [
              { required: true, message: 'Please Enter Description', trigger: 'blur' },
            ],
            sort_order: [
                {  required: true, message: 'Please Enter Sort Order', trigger: 'blur' },
                { type: 'integer', message: 'Please Enter A Number', trigger: 'blur'}
            ],
          },
          tax_pricing_matrix: {
            country: [
              { required: true, message: 'Please Enter Country', trigger: 'blur' }
            ],
            tax: [
              { required: true, message: 'Please Enter Rate', trigger: 'blur' },
              // { type: 'integer', message: 'Please Enter A Number', trigger: 'blur'}
            ],
          }
        },
        tax: {
          name:'',
          description:'',
          sort_order:'',
          updated_user_id: ''
        },
        form_rate_show: false,
        form_rate_mode: '',
        tax_pricing_matrix: [
          {
            id:'',
            country:'',
            state:'',
            tax:'',
            tax_class_id:'',
            created_at:'',
            updated_at:'',
          }
        ],
        matrix: {
          id:'',
          country:'',
          state:'',
          tax:'',
          tax_class_id:'',
          created_at:'',
          updated_at:'',
        },
      };
    },

    mounted: function() {
      const me = this;
      me.getTax();
      me.getPricingMatrix();
    },

    methods: {
      getTax: function() {
        console.log('get tax function');
        const me = this;
        me.$http.get(me.config.api + 'taxClasses/{id}', {params: {id : me.$route.params.id}}).then(
          response => {
            console.log('Success Getting Data')  
            console.log(response.status);
            console.log(response.statusText);
            me.tax = response.body.data;
          }, response => {
            console.log('Error Getting Data');
            console.log(response.status);
            console.log(response.statusText);
          }
        );
      },

      getPricingMatrix: function() {
        console.log('get pricing matrix function');
        const me = this;
        me.$http.get(me.config.api + 'taxClasses/{id}/pricingMatrix', {params: {id : me.$route.params.id, pagination: 1000}}).then(
          response => {
            console.log('Success Getting Data')  
            console.log(response.status);
            console.log(response.statusText);
            console.log(response);
            me.tax_pricing_matrix = response.body.data;
          }, response => {
            console.log('Error Getting Data');
            console.log(response.status);
            console.log(response.statusText);
          }
        );
      },

      // show and hide the add edit rate form
      toggleFormRate: function(action) {
        console.log('toggle form rate');
        const me = this;
        me.form_rate_show = !me.form_rate_show;
        me.form_rate_mode = action;    
      },

      getMatrix: function(matrixID) {
        console.log('get single matrix function');
        const me = this;
        me.loading = true;
        me.$http.get(me.config.api + 'taxClasses/{id}/pricingMatrix', {params: {id : me.$route.params.id, matriceid: matrixID}}).then(
          response => {
            console.log('Success Getting Data')  
            console.log(response.status);
            console.log(response.statusText);
            me.matrix = response.body.data[0]; // remove hot fix [0] after
            me.form_rate_show = true;
            me.form_rate_mode = 'Update';
            me.loading = false;
          }, response => {
            console.log('Error Getting Data');
            console.log(response.status);
            console.log(response.statusText);
            me.$notify({
              title: 'Error',
              message: response.statusText,
              type: 'error'
            });
            me.loading = false;
          }
        );
      },

      updateMatrix: function(formName){
        console.log('update matrix function');
        const me = this;
        // me.matrix.tax_class_id = me.$route.params.id;
        me.$refs[formName].validate((valid) => {
          if (valid) {
            me.$http.put(me.config.api + 'taxClasses/{taxClassId}/pricingMatrix/{matrixId}', me.matrix, {params: {taxClassId : me.$route.params.id, matrixId: me.matrix.id }}).then(
            response => {
              console.log('success putting data')  
              console.log(response.status);
              console.log(response.statusText);
              me.getPricingMatrix();
              me.form_rate_show = false;
              me.form_rate_mode = '';
              // Success message
              me.$notify({
                title: 'Success',
                message: 'The Tax Was Added',
                type: 'success'
              });
            }, response => {
              console.log('Error Getting Data');
              console.log(response.status);
              console.log(response.statusText);
            });
          } else {
              console.log('Fields Not Valid');
              return false;
          }
        });                  
      },

      updateTax: function(formName) {
        console.log('update tax function');
        const me = this;
        me.$refs[formName].validate((valid) => {
          if (valid) {
            var jwt = Utils.decodejwt();
            me.tax.updated_user_id = jwt.sub;
            me.$http.put(me.config.api + 'taxClasses/{id}', me.tax, {params: {id : me.$route.params.id}}).then(
              response => {
                console.log('success putting data')  
                console.log(response.status);
                console.log(response.statusText);
                me.getTax();
                me.$notify({
                  title: 'Success',
                  message: 'The Tax Was Updated',
                  type: 'success'
                });
              }, response => {
                console.log('Error Getting Data');
                console.log(response.status);
                console.log(response.statusText);
              }
            );
          } else {
            console.log('Fields Not Valid');
            return false;
          }
        });
      },

      deleteMatrix: function(id) {
        console.log('delete tax rate function');
        const me = this;
        me.$confirm('This Will Permanently Delete The Tax Rate - Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          me.$http.delete(me.config.api + 'taxClasses/{taxClassId}/pricingMatrix/{matrixId}', {params: {taxClassId : me.$route.params.id, matrixId: id }}).then(
          response => {
            console.log('success posting data')  
            console.log(response.status);
            console.log(response.statusText);
            me.getPricingMatrix();
            me.$notify({
              title: 'Success',
              message: 'The Tax Matrix Was Deleted',
              type: 'success'
            });
          }, response => {
            console.log('error deleting data');
            console.log(response.status);
            console.log(response.statusText);
            console.log(response.bodyText);
          });
        }).catch(() => {
          me.$message({
            type: 'info',
            message: 'Delete canceled'
          });          
        });
      },

      addMatrix(formName){
        console.log('add matrix function');
        const me = this;
        me.matrix.tax_class_id = me.$route.params.id;
        me.$refs[formName].validate((valid) => {
          if (valid) {
            me.$http.post(me.config.api + 'taxClasses/{id}/pricingMatrix', me.matrix, {params: {id : me.$route.params.id}}).then(
            response => {
              console.log('success putting data')  
              console.log(response.status);
              console.log(response.statusText);
              me.resetForm('matrix');
              me.matrix = {};
              me.form_rate_show = false;
              me.form_rate_mode = '';
              me.getPricingMatrix;
              me.$notify({
                title: 'Success',
                message: 'The Tax Matrix Was Added',
                type: 'success'
              });
            }, response => {
              console.log('Error Getting Data');
              console.log(response.status);
              console.log(response.statusText);
            });
          } else {
            console.log('Fields Not Valid');
            return false;
          }
        });                  
      },

      resetForm(formName) {
        const me = this;
        me.$refs[formName].resetFields();
      }
    }
  }
</script>





// WEBPACK FOOTER //
// src/pages/tax/TaxEdit.vue